import * as React from "react";
const SvgWrongLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m7.758 6.343 4.241 4.242 4.244-4.242a1 1 0 1 1 1.414 1.414L13.415 12l4.292 4.294a1 1 0 0 1-1.414 1.414L12 13.414l-4.242 4.243a1 1 0 0 1-1.415-1.414l4.243-4.244-4.243-4.242a1 1 0 0 1 1.415-1.414", clipRule: "evenodd" }));
export default SvgWrongLine;
